import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Handles Angular ChunkLoadError that occurs when lazy-loaded JS chunks
 * are missing after a new deployment. The browser has the old runtime that
 * references chunk hashes that no longer exist on the server.
 *
 * Strategy: reload once per missing chunk (tracked in sessionStorage to
 * prevent infinite reload loops if the chunk is genuinely absent).
 */
@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const err = error as { name?: string; message?: string; request?: string };

    const isChunkError =
      err?.name === 'ChunkLoadError' ||
      (typeof err?.message === 'string' && err.message.includes('Loading chunk'));

    if (isChunkError) {
      const chunkId = err?.request ?? 'unknown';
      const storageKey = `chunk_reload_${chunkId}`;

      if (!sessionStorage.getItem(storageKey)) {
        sessionStorage.setItem(storageKey, '1');
        window.location.reload();
        return;
      }
    }

    console.error(error);
  }
}
